import { useEffect, useMemo } from "react";
import Loader from "../../components/common/Loader";
import { useAuthStore } from "../../stores/useAuthStore";
import { useFirebaseStore } from "../../stores/useFirebaseStore";
import { NoItemsFound } from "../../components/common/NoItemsFound";
import { MovieItem } from "../../components/movie-item";
import "./index.css";

interface WatchListCompProps {
  searchQuery?: string;
}

export const WatchListComp = ({ searchQuery = "" }: WatchListCompProps) => {
  const { profile } = useAuthStore();
  const isLoggedIn = Object.keys(profile).length > 0;
  const { fetchWatchListMovies, watchListMovies, isLoading } =
    useFirebaseStore();

  useEffect(() => {
    if (isLoggedIn) {
      fetchWatchListMovies();
    }
  }, [fetchWatchListMovies, isLoggedIn]);

  const filteredMovies = useMemo(() => {
    if (!searchQuery.trim()) return watchListMovies;

    const query = searchQuery.toLowerCase();
    return watchListMovies.filter((item) => {
      const title = item.movie.title.toLowerCase();
      const overview = (item.movie.overview || "").toLowerCase();
      return title.includes(query) || overview.includes(query);
    });
  }, [watchListMovies, searchQuery]);

  if (isLoading && watchListMovies.length === 0) {
    return <Loader />;
  }

  if (watchListMovies.length === 0) {
    return <NoItemsFound text="No movies in watchlist!" />;
  }

  if (filteredMovies.length === 0) {
    return <NoItemsFound text={`No movies found for "${searchQuery}"`} />;
  }

  return (
    <div className="grid-container">
      {filteredMovies.map((obj) => {
        return <MovieItem key={obj.movieId} movie={obj.movie} />;
      })}
    </div>
  );
};
